import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ExpiryStateStore {
  private readonly _selectedExpiryDate = signal<Date | null>(null);

  public get selectedExpiryDate() {
    return this._selectedExpiryDate.asReadonly();
  }

  public setSelectedDate(date: Date | null) {
    this._selectedExpiryDate.set(date);
  }

  public clearSelectedDate() {
    this._selectedExpiryDate.set(null);
  }
}